module.exports = __webpack_public_path__ + "assets/Robbery.340a8af9.svg";